import React, { Component } from 'react'
import PropTypes from 'prop-types'

import CampaignQuotesWrapper from 'agency/digital_renderer/components/CampaignQuotesWrapper'

import ContentHolder from '../../ui/ContentHolder'
import Quote from './Quote'
import styles from './styles.scss'

class CampaignQuotes extends Component {
  _renderQuoteToggle = (params) => {
    const { campaignQuotes, selectedQuoteId, selectQuoteId } = params
    if (!campaignQuotes.length) return null

    return (
      <ul className={styles.quoteToggle}>
        {campaignQuotes.map(quote => (
          <li key={quote.id}>
            <a
              className={quote.id === selectedQuoteId ? styles.selected : null}
              tabIndex="0"
              onClick={() => selectQuoteId(quote.id)}
            >
              {quote.title}
            </a>
          </li>
        ))}
      </ul>
    )
  }

  _renderQuote = (params) => {
    const { brand } = this.props
    const { campaignQuote } = params

    return <Quote brand={brand} campaignQuote={campaignQuote} />
  }

  _renderContent = params => (
    <div className={styles.root}>
      <ContentHolder>
        <h1>Campaign Quotes</h1>

        <p className={styles.intro}>
          Below is an outline of the marketing we believe will produce the most successful campaign for your property.
          We&apos;ve refined our marketing packages over time to produce the best possible results.
        </p>

        {this._renderQuoteToggle(params)}

        {this._renderQuote(params)}
      </ContentHolder>
    </div>
  )

  render(){
    const { campaignProposal } = this.props

    return <CampaignQuotesWrapper dataSource={campaignProposal} render={params => this._renderContent(params)} />
  }
}

CampaignQuotes.propTypes = {
  brand: PropTypes.object.isRequired,
  campaignProposal: PropTypes.object.isRequired,
}

export default CampaignQuotes
